import _classCallCheck from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
/*
  * 对Date的扩展，将 Date 转化为指定格式的String
  * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符、毫秒(S) 1-3个占位符
  * 年(y)可以用 1-4 个占位符
  * 例子：
  * (new Date()).format("yyyy-MM-dd hh:mm:ss.SSS") ==> 2006-07-02 08:09:04.423
  * (new Date()).format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.4(毫秒从高位-低位依次取)
*/
export function format(date, fmt) {
  var formated = fmt;
  var o = {
    'M+': date.getMonth() + 1,
    // 月份
    'd+': date.getDate(),
    // 日
    'h+': date.getHours(),
    // 小时
    'm+': date.getMinutes(),
    // 分
    's+': date.getSeconds(),
    // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 季度
    'S+': date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(formated)) formated = formated.replace(RegExp.$1, "".concat(date.getFullYear()).substr(4 - RegExp.$1.length));
  Object.keys(o).forEach(function (key) {
    if (new RegExp("(".concat(key, ")")).test(formated)) {
      if (key === 'S+') {
        var start = "00".concat(o[key]).length - 3;
        formated = formated.replace(RegExp.$1, "00".concat(o[key]).substr(start, RegExp.$1.length));
      }
      formated = formated.replace(RegExp.$1, RegExp.$1.length === 1 ? o[key] : "00".concat(o[key]).substr("".concat(o[key]).length));
    }
  });
  return formated;
}

// 当前日期
var now = new Date();
// 今天本周的第几天
var nowDayOfWeek = now.getDay();
// 当前日
var nowDay = now.getDate();
// 当前月
var nowMonth = now.getMonth();
// 当前年
var nowYear = now.getYear();
nowYear += nowYear < 2000 ? 1900 : 0;
var DateUtils = /*#__PURE__*/function () {
  function DateUtils() {
    _classCallCheck(this, DateUtils);
  }
  return _createClass(DateUtils, null, [{
    key: "parseLongDate",
    value: function parseLongDate(dateStr) {
      return Date.parse(dateStr.replace(/-/g, '/'));
    }

    // 格式化日期：yyyy-MM-dd
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = '0' + mymonth;
      }
      if (myweekday < 10) {
        myweekday = '0' + myweekday;
      }
      return myyear + '-' + mymonth + '-' + myweekday;
    }

    // 格式化日期：yyyy-MM-dd
  }, {
    key: "formatLongDate",
    value: function formatLongDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();
      var myHour = date.getHours();
      var myMin = date.getMinutes();
      var mySec = date.getSeconds();
      if (mymonth < 10) {
        mymonth = '0' + mymonth;
      }
      if (myweekday < 10) {
        myweekday = '0' + myweekday;
      }
      if (myHour < 10) {
        myHour = '0' + myHour;
      }
      if (myMin < 10) {
        myMin = '0' + myMin;
      }
      if (mySec < 10) {
        mySec = '0' + mySec;
      }
      return myyear + '-' + mymonth + '-' + myweekday + ' ' + myHour + ':' + myMin + ':' + mySec;
    }

    // 获得某月的天数
  }, {
    key: "getMonthDays",
    value: function getMonthDays(myMonth) {
      var monthStartDate = new Date(nowYear, myMonth, 1);
      var monthEndDate = new Date(nowYear, myMonth + 1, 1);
      var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
      return days;
    }

    // 获得本季度的开始月份
  }, {
    key: "getQuarterStartMonth",
    value: function getQuarterStartMonth() {
      var quarterStartMonth = 0;
      if (nowMonth < 3) {
        quarterStartMonth = 0;
      }
      if (nowMonth > 2 && nowMonth < 6) {
        quarterStartMonth = 3;
      }
      if (nowMonth > 5 && nowMonth < 9) {
        quarterStartMonth = 6;
      }
      if (nowMonth > 8) {
        quarterStartMonth = 9;
      }
      return quarterStartMonth;
    }

    // 获得本周的开始日期
  }, {
    key: "getWeekStartDate",
    value: function getWeekStartDate() {
      var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
      return this.formatDate(weekStartDate);
    }

    // 获得本周的结束日期
  }, {
    key: "getWeekEndDate",
    value: function getWeekEndDate() {
      var weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
      return this.formatDate(weekEndDate);
    }

    // 获得本月的开始日期
  }, {
    key: "getMonthStartDate",
    value: function getMonthStartDate() {
      var monthStartDate = new Date(nowYear, nowMonth, 1);
      return this.formatDate(monthStartDate);
    }

    // 获得本月的结束日期
  }, {
    key: "getMonthEndDate",
    value: function getMonthEndDate() {
      var monthEndDate = new Date(nowYear, nowMonth, this.getMonthDays(nowMonth));
      return this.formatDate(monthEndDate);
    }

    // 获得本季度的开始日期
  }, {
    key: "getQuarterStartDate",
    value: function getQuarterStartDate() {
      var quarterStartDate = new Date(nowYear, this.getQuarterStartMonth(), 1);
      return this.formatDate(quarterStartDate);
    }

    // 或的本季度的结束日期
  }, {
    key: "getQuarterEndDate",
    value: function getQuarterEndDate() {
      var quarterEndMonth = this.getQuarterStartMonth() + 2;
      var quarterStartDate = new Date(nowYear, quarterEndMonth, this.getMonthDays(quarterEndMonth));
      return this.formatDate(quarterStartDate);
    }
  }, {
    key: "getDateWeek",
    value: function getDateWeek(date) {
      var week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      return week[date.getDay()];
    }
  }, {
    key: "utc2beijing",
    value: function utc2beijing(utc_datetime) {
      // 转为正常的时间格式 年-月-日 时:分:秒
      var T_pos = utc_datetime.indexOf('T');
      var Z_pos = utc_datetime.indexOf('Z');
      var year_month_day = utc_datetime.substr(0, T_pos);
      var hour_minute_second = utc_datetime.substr(T_pos + 1, Z_pos - T_pos - 1);
      var new_datetime = year_month_day + ' ' + hour_minute_second; // 2017-03-31 08:02:06
      // 处理成为时间戳
      timestamp = new Date(Date.parse(new_datetime));
      timestamp = timestamp.getTime();
      timestamp = timestamp / 1000;
      // 增加8个小时，北京时间比utc时间多八个时区
      var timestamp = timestamp + 8 * 60 * 60;
      // 时间戳转为时间
      var date = new Date(parseInt(timestamp) * 1000);
      // let beijing_datetime =date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      var beijing_datetime = y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
      return beijing_datetime; // 2017-03-31 16:02:06
    }
  }]);
}();
export default DateUtils;